import { keyframes, styled } from 'styled-components';

const aFloat = keyframes`
  0% {
    transform: translate(0,  0px) rotateZ(0);
  }
  50% {
    transform: translate(0, -6px) rotateZ(0);
  }
  100% {
    transform: translate(0, -0px) rotateZ(0);
  }
`;

const aFloatShadow = keyframes`
  0% {
    transform: translateX(-50%) scale(1, 1) rotateZ(0);
  }
  50% {
    transform: translateX(-50%) scale(0.8, 0.9) rotateZ(0);
  }
  100% {
    transform: translateX(-50%) scale(1, 1) rotateZ(0);
  }
`;

export const FloatingImageHolder = styled.div`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    width: 50%;
    padding-bottom: 10%;
    border-radius: 50%;
    background: rgb(0 0 0 / 0.04);
    animation: ${aFloatShadow} 3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
    will-change: transform;
  }

  img {
    position: relative;
    width: 100%;
    animation: ${aFloat} 3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
    will-change: transform;
  }
`;
